module.exports = __webpack_public_path__ + "static/media/icon_close.76cae34c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_close.svg
// module id = 32
// module chunks = 0